import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ChangeCalendarConfigModalComponent } from '../../../../app/home/paraEmpresas/calendar/changeConfig/content.component';
import { RemoveCalendarModalComponent } from '../../../../app/home/paraEmpresas/calendar/remove/content.component';
import { RemoveSpecialDayComponent } from '../../../../app/home/paraEmpresas/calendar/removeSpecialDay/content.component';

import { SetCalendarModalComponent } from '../../../../app/home/paraEmpresas/calendar/set/content.component';
import { UnsetCalendarModalComponent } from '../../../../app/home/paraEmpresas/calendar/unset/content.component';
import { CalendarService } from '../../../../app/services/calendar.service';
import { AlertService } from '../../../../app/utils/alert.service';
import { DataPackCalendar } from '../../../../app/models/dataPackCalendar.model';
import { DataPackCalendarPeriod } from '../../../../app/models/dataPackCalendarPeriod.model';
import { DataPackGroup } from '../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../app/models/dataPackLine.model';
import { DataPackCalendarSpecialDays } from '../../../../app/models/dataPackCalendarSpecialDays.model';
import { DataPackCalendarSpecialDayConf } from '../../../../app/models/dataPackCalendarSpecialDayConf.model';
import { BindComponentService } from '../../../../app/utils/bind.component.service';
import { LoadingComponent } from '../../../../app/home/paraEmpresas/modalLoading/content.component';

import * as _ from "lodash";
import * as moment from 'moment';

/**
 * @version $Id: content.component.ts 88077 2018-04-26 20:54:50Z bernardo.d.siqueira $
 */
@Component({
  templateUrl: './content.template.html'
})
export class CalendarComponent implements OnInit {

  private static readonly GROUPS_FETCH_SIZE: number = 20;
  private static readonly LINES_FETCH_SIZE: number = 20;
  private static readonly FILTER_ALL_LINES = 'all_lines';
  private static readonly FILTER_LINES_WITH_CALENDAR = 'lines_with_calendar';
  private static readonly FILTER_LINES_WITHOUT_CALENDAR = 'lines_without_calendar';
  private static readonly UNDERTERMINED = 'undetermined';
  private static readonly DERTERMINED = 'determined';
  private static readonly WORKING_DAYS = 'workingDays';

  public calendars: Array<DataPackCalendar> = new Array<DataPackCalendar>();
  public groups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public lines: Array<DataPackLine> = new Array<DataPackLine>();
  public filter: string = CalendarComponent.FILTER_ALL_LINES;
  public filterValue: string = '';
  public filteredGroups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public selectedGroup: DataPackGroup;
  public selectedLine: DataPackLine;
  public selectedLines: Map<string, DataPackLine> = new Map<string, DataPackLine>();
  public businessHourPeriods: Array<any> = new Array<any>();
  public hourByHourPeriods: Array<any> = new Array<any>();
  public originalPeriods: Array<DataPackCalendarPeriod>;
  public specialDays: Array<DataPackCalendarSpecialDays> = new Array<DataPackCalendarSpecialDays>();
  public groupsFetchSize: number = CalendarComponent.GROUPS_FETCH_SIZE;
  public linesFetchSize: number = CalendarComponent.LINES_FETCH_SIZE;
  public displayShowMoreGroupsButton: boolean = false;
  public displayShowMoreLinesButton: Map<number, boolean> = new Map<number, boolean>();
  public groupSortingCriteria: string;
  public groupSortingAsc: boolean = true;
  public lineSortingCriteria: string;
  public lineSortingAsc: boolean = true;
  public editingCalendar: boolean = false;
  public savingCalendar: boolean = false;
  public createSpecialDays: boolean = false;
  public calendar: any;
  public hourPattern: string = '^\\d\\d:\\d\\d$';
  public hourFormat: string = 'HH:mm';
  public selectedSpecialDate: any;
  public description: string;
  public disableSaveDaySpecial: boolean = true;
  public pageGroup: number;
  public page: number;

  constructor(private modal: NgbModal, private datePickerConfig: NgbDatepickerConfig, private calendarService: CalendarService, private alertService: AlertService, private bindComponent: BindComponentService, private modalService: NgbModal) {

  }

  ngOnInit() {
    this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'CALENDAR_FILTER'); //ALTERADO
    this.configureDatepicker();
    this.loadView();
  }

  private configureDatepicker() {
    let now = moment();
    this.datePickerConfig.minDate = {
      year: now.get('year'),
      month: now.get('month') + 1,
      day: now.get('date')
    };
  }
  private reset() {
    this.displayShowMoreGroupsButton = true;
  }

  private loadView() {
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.reset();    
    this.calendarService.loadView(1, CalendarComponent.GROUPS_FETCH_SIZE).subscribe(
      data => {
        this.setCalendars(data['calendars']);
        this.setGroups(data['groups'], false);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.pageGroup = 1;
      },
      err => {
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      }
    );
  }

 private clearSelection(){
  this.selectedLines.clear();
  this.lineSortingCriteria = null;
  this.lineSortingAsc = true;
  this.groupSortingCriteria = null;
  this.groupSortingAsc = true;
 }

  private setCalendars(calendars: Array<DataPackCalendar>) {
    this.calendars = calendars;
  }
  private setGroups(groups: Array<DataPackGroup>, append: boolean) {
    if (!append) {
      this.groups = groups;
    } else {
      Array.prototype.push.apply(this.groups, groups);
    }
    this.selectedLines.clear();
    this.selectedGroup = null;
    this.lines = null;
    this.lineSortingCriteria = null;
    this.lineSortingAsc = true;
    this.groupSortingCriteria = null;
    this.groupSortingAsc = true;
    this.filterLines();
  }

  private setLines(group: DataPackGroup, lines: Array<DataPackLine>, append: boolean) {
    if (!append) {
      group.lines = lines;
    } else {
      Array.prototype.push.apply(group.lines, lines);
    }
    this.filterLines();
  }

  private filterLines(filter?: string) {
    this.clearSelection();
    this.filter = filter || this.filter;
    this.filteredGroups = this.groups.filter(group => {
      let groupFiltered = false;
      group.lines.forEach(line => {
        groupFiltered = true;
        line.filtered = false;
        let lineFiltered = !this.filterValue || this.filterValue === '' || this.searchText(line.userName, this.filterValue) || this.searchText(line.lineNumber, this.filterValue);
        if (lineFiltered && (this.filter === CalendarComponent.FILTER_ALL_LINES || (this.filter === CalendarComponent.FILTER_LINES_WITH_CALENDAR && line.calendar) || (this.filter === CalendarComponent.FILTER_LINES_WITHOUT_CALENDAR && !line.calendar))) {
          line.filtered = lineFiltered;
        }
      });
      return groupFiltered;
    });
  }

  private searchText(text: string, value: string) {
    return text ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
  }

  private toggleGroup(group: DataPackGroup) {
    if (!this.selectedGroup || this.selectedGroup.id !== group.id) {
      this.selectedGroup = group;
      this.lines = group.lines;
      this.page = 1;
    } else {
      this.selectedGroup = null;
      this.lines = null;
    }
    this.lineSortingCriteria = null;
    this.lineSortingAsc = true;
    this.selectedLines.clear();
  }

  private sortGroups(field: string) {
    this.groupSortingAsc = this.groupSortingCriteria == field ? !this.groupSortingAsc : true;
    this.groupSortingCriteria = field;
    this.filteredGroups = _.orderBy(this.filteredGroups, [this.groupSortingCriteria], [this.groupSortingAsc ? 'asc' : 'desc']);
  }

  private sortLines(field: string) {
    this.lineSortingAsc = this.lineSortingCriteria == field ? !this.lineSortingAsc : true;
    this.lineSortingCriteria = field;
    this.lines = _.orderBy(this.lines, [this.lineSortingCriteria], [this.lineSortingAsc ? 'asc' : 'desc']);
  }

  private selectLine(line: DataPackLine) {
    if (!this.selectedLines.has(line.lineNumber)) {
      this.selectedLines.set(line.lineNumber, line);
    } else {
      this.selectedLines.delete(line.lineNumber);
    }
  }

  private selectAllLines($event) {
    let checked = $event.srcElement.checked;
    if (checked) {
      this.selectedGroup.lines.forEach(line => this.selectedLines.set(line.lineNumber, line));
    } else {
      this.selectedLines.clear();
    }
  }

  private showMoreGroups() {
    this.openModalLoading();
    this.pageGroup = this.pageGroup +1;
    this.calendarService.listGroups(this.pageGroup, this.groupsFetchSize).subscribe(
      data => {        
        this.setGroups(data['groups'], true);
        if (data['groups'].length < this.groupsFetchSize) {
          this.displayShowMoreGroupsButton = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private showMoreLines() {
    this.openModalLoading();
    this.page = this.page+1;
    this.calendarService.listLines(this.selectedGroup, this.page, this.linesFetchSize).subscribe(
      data => {
        let dataLines: any =data;
        this.setLines(this.selectedGroup, dataLines, true);
        if (dataLines.length < this.linesFetchSize) {
          this.displayShowMoreLinesButton[this.selectedGroup.id] = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private openSaveCalendarForm(calendar: DataPackCalendar) {
    let determined = this.isDeterminedCalendar(calendar);
    this.originalPeriods = [];
    this.calendar = {};
    this.calendar.innerCalendar = calendar;
    this.calendar.id = calendar ? calendar.id : null;
    this.calendar.description = calendar ? calendar.description : '';
    this.calendar.descriptionOld = calendar ? calendar.description : '';
    this.calendar.validity = determined ? CalendarComponent.DERTERMINED : CalendarComponent.UNDERTERMINED;
    this.calendar.businessHour = calendar ? calendar.businessHour : true;
    this.calendar.detailed = calendar ? calendar.detailed : false;
    if (calendar && determined) {
      let initialDate = moment(calendar.initialDate);
      let initialDateObj = { year: initialDate.year(), month: initialDate.month() + 1, day: initialDate.date() };
      this.calendar.initialDate = initialDateObj;
    }
    if (calendar && determined) {
      let endDate = moment(calendar.endDate);
      let endDateObj = { year: endDate.year(), month: endDate.month() + 1, day: endDate.date() };
      this.calendar.endDate = endDateObj;
    }
    this.createPeriods(true);
    this.editingCalendar = true;
  }

  private formatDate(date: string) {
    return moment(date).format('DD/MM/YYYY');
  }

  private isDeterminedCalendar(calendar: DataPackCalendar) {
    return calendar && moment(calendar.initialDate).year() > 1970 && moment(calendar.initialDate).year() < 2999;
  }

  private createPeriods(useInnerCalendar: boolean) {
    if (this.calendar.businessHour) {
      this.createBusinessHourPeriods(useInnerCalendar);
    } else {
      this.createHourByHourPeriods(useInnerCalendar);
    }
  }
  private createBusinessHourPeriods(useInnerCalendar: boolean) {
    let periodsIndexed = {};
    if (useInnerCalendar && this.calendar.innerCalendar && this.calendar.innerCalendar.allPeriods.length > 0) {
      this.calendar.periods = this.calendar.innerCalendar.allPeriods;
      this.calendar.innerCalendar.allPeriods.forEach((innerPeriod) => {
        innerPeriod.blockStatus = { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true, nationalHolidays: true, localHolidays: true };
        periodsIndexed[innerPeriod.endHour] = innerPeriod;
      });
    } else {
      let first = {
        initialHour: '00:00',
        endHour: '07:59',
        blockStatus: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true, nationalHolidays: true, localHolidays: true }
      };
      periodsIndexed[first.endHour] = first;
      let second = {
        initialHour: '08:00',
        endHour: '11:59',
        blockStatus: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true, nationalHolidays: true, localHolidays: true }
      };
      periodsIndexed[second.endHour] = second;
      let third = {
        initialHour: '12:00',
        endHour: '13:59',
        blockStatus: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true, nationalHolidays: true, localHolidays: true }
      };
      periodsIndexed[third.endHour] = third;
      let fourth = {
        initialHour: '14:00',
        endHour: '17:59',
        blockStatus: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true, nationalHolidays: true, localHolidays: true }
      };
      periodsIndexed[fourth.endHour] = fourth;
      let fifth = {
        initialHour: '18:00',
        endHour: '23:59',
        blockStatus: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true, nationalHolidays: true, localHolidays: true }
      };
      periodsIndexed[fifth.endHour] = fifth;
      this.calendar.periods = [];
      this.calendar.periods.push(first);
      this.calendar.periods.push(second);
      this.calendar.periods.push(third);
      this.calendar.periods.push(fourth);
      this.calendar.periods.push(fifth);
    }
    this.originalPeriods = _.cloneDeep(this.calendar.periods);
    if (useInnerCalendar && this.calendar.innerCalendar) {
      this.replacePeriods(periodsIndexed);
    }
  }
  private createHourByHourPeriods(useInnerCalendar: boolean) {
    let periodsIndexed = {};
    this.calendar.periods = [];
    for (let hour = 0; hour <= 23; hour++) {
      let fixedHour = _.padStart(String(hour), 2, '0');
      let period = {
        initialHour: fixedHour + ':00',
        endHour: fixedHour + ':59',
        blockStatus: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true, nationalHolidays: true, localHolidays: true }
      };
      this.calendar.periods.push(period);
      periodsIndexed[period.endHour] = period;
    }
    if (useInnerCalendar && this.calendar.innerCalendar) {
      this.replacePeriods(periodsIndexed);
    }
  }

  private replacePeriods(periodsIndexed: any) {
    this.calendar.innerCalendar.periods.forEach((innerPeriod) => {
      let weekDays = innerPeriod.weekDays.match(/\d{1}/g);
      let initialHour = moment(innerPeriod.initialDate + ' ' + innerPeriod.initialHour);
      let endHour = moment(innerPeriod.endDate + ' ' + innerPeriod.endHour);
      let period = {
        initialHour: _.padStart(String(initialHour.hour()), 2, '0') + ':' + _.padStart(String(initialHour.minute()), 2, '0'),
        endHour: _.padStart(String(endHour.hour()), 2, '0') + ':' + _.padStart(String(endHour.minute()), 2, '0'),
        blockStatus: {
          monday: !_.includes(weekDays, '2'),
          tuesday: !_.includes(weekDays, '3'),
          wednesday: !_.includes(weekDays, '4'),
          thursday: !_.includes(weekDays, '5'),
          friday: !_.includes(weekDays, '6'),
          saturday: !_.includes(weekDays, '7'),
          sunday: !_.includes(weekDays, '1'),
          nationalHolidays: !_.includes(weekDays, '9'),
          localHolidays: !_.includes(weekDays, '8')
        }
      };
      let newPeriod = periodsIndexed[period.endHour];
      newPeriod.initialHour = period.initialHour;
      newPeriod.endHour = period.endHour;
      newPeriod.blockStatus = period.blockStatus;
    });
  }

  private changeToBusinessHour($event: any, businessHour: boolean) {
    $event.preventDefault();
    let modalRef = this.modal.open(ChangeCalendarConfigModalComponent);
    modalRef.componentInstance.type = 'hour_range';
    modalRef.result.then(
      result => {
        this.calendar.businessHour = businessHour;
        this.createPeriods(false);
      },
      reason => null
    );
  }

  private changeToDetailed($event: any, detailed: boolean) {
    $event.preventDefault();
    let modalRef = this.modal.open(ChangeCalendarConfigModalComponent);
    modalRef.componentInstance.type = 'working_days';
    modalRef.result.then(
      result => {
        this.calendar.detailed = detailed;
        this.createPeriods(false);
      },
      reason => null
    );
  }

  private isWorkingDaysUnblocked(period: any) {
    return !period.blockStatus.monday && !period.blockStatus.tuesday && !period.blockStatus.wednesday && !period.blockStatus.thursday && !period.blockStatus.friday;
  }

  private toggleWorkingDaysBlock(period: any) {
    let status = period.blockStatus.monday;
    period.blockStatus.monday = !status;
    period.blockStatus.tuesday = !status;
    period.blockStatus.wednesday = !status;
    period.blockStatus.thursday = !status;
    period.blockStatus.friday = !status;
  }

  private blockEverything(day) {
    for (let index in this.calendar.periods) {
      let period = this.calendar.periods[index];
      if (day === CalendarComponent.WORKING_DAYS) {
        period.blockStatus.monday = true;
        period.blockStatus.tuesday = true;
        period.blockStatus.wednesday = true;
        period.blockStatus.thursday = true;
        period.blockStatus.friday = true;
      } else {
        period.blockStatus[day] = true;
      }
    }
  };

  private releaseEverything(day) {
    for (let index in this.calendar.periods) {
      let period = this.calendar.periods[index];
      if (day === CalendarComponent.WORKING_DAYS) {
        period.blockStatus.monday = false;
        period.blockStatus.tuesday = false;
        period.blockStatus.wednesday = false;
        period.blockStatus.thursday = false;
        period.blockStatus.friday = false;
      } else {
        period.blockStatus[day] = false;
      }
    }
  };

  private isEverythingBlocked(day) {
    for (let index in this.calendar.periods) {
      let period = this.calendar.periods[index];
      if (day === CalendarComponent.WORKING_DAYS) {
        if (!period.blockStatus.monday || !period.blockStatus.tuesday || !period.blockStatus.wednesday || !period.blockStatus.thursday || !period.blockStatus.friday) {
          return false;
        }
      } else {
        if (!period.blockStatus[day]) {
          return false;
        }
      }
    }
    return true;
  }

  private isEverythingReleased(day) {
    for (let index in this.calendar.periods) {
      let period = this.calendar.periods[index];
      if (day === CalendarComponent.WORKING_DAYS) {
        if (period.blockStatus.monday || period.blockStatus.tuesday || period.blockStatus.wednesday || period.blockStatus.thursday || period.blockStatus.friday) {
          return false;
        }
      } else {
        if (period.blockStatus[day]) {
          return false;
        }
      }
    }
    return true;
  }

  private toDataPackCalendar() {
    let determined = this.calendar.validity === CalendarComponent.DERTERMINED;
    let dataPackCalendar = new DataPackCalendar();
    dataPackCalendar.id = this.calendar.id;
    dataPackCalendar.descriptionOld = this.calendar.descriptionOld;
    dataPackCalendar.description = this.calendar.description;
    dataPackCalendar.businessHour = this.calendar.businessHour;
    dataPackCalendar.detailed = this.calendar.detailed;
    if (determined) {
      dataPackCalendar.initialDate = moment().year(this.calendar.initialDate.year).month(this.calendar.initialDate.month - 1).date(this.calendar.initialDate.day).format('YYYY-MM-DD');
      dataPackCalendar.endDate = moment().year(this.calendar.endDate.year).month(this.calendar.endDate.month - 1).date(this.calendar.endDate.day).format('YYYY-MM-DD');
    } else {
      dataPackCalendar.initialDate = moment().year(1970).month(0).date(1).format('YYYY-MM-DD');
      dataPackCalendar.endDate = moment().year(2999).month(0).date(1).format('YYYY-MM-DD');
    }
    dataPackCalendar.periods = new Array<DataPackCalendarPeriod>();
    dataPackCalendar.allPeriods = new Array<DataPackCalendarPeriod>();

    for (let index in this.calendar.periods) {
      let period = this.calendar.periods[index];
      let dataPackCalendarPeriod = new DataPackCalendarPeriod();
      dataPackCalendarPeriod.initialHour = period.initialHour;
      dataPackCalendarPeriod.endHour = period.endHour;
      dataPackCalendarPeriod.initialDate = dataPackCalendar.initialDate;
      dataPackCalendarPeriod.endDate = dataPackCalendar.endDate;
      dataPackCalendarPeriod.weekDays = '';
      if (!period.blockStatus.sunday) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('1');
      }
      if (!period.blockStatus.monday) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('2');
      }
      if (!period.blockStatus.tuesday) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('3');
      }
      if (!period.blockStatus.wednesday) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('4');
      }
      if (!period.blockStatus.thursday) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('5');
      }
      if (!period.blockStatus.friday) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('6');
      }
      if (!period.blockStatus.saturday) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('7');
      }
      if (!period.blockStatus.localHolidays) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('8');
      }
      if (!period.blockStatus.nationalHolidays) {
        dataPackCalendarPeriod.weekDays = dataPackCalendarPeriod.weekDays.concat('9');
      }
      if (dataPackCalendarPeriod.weekDays.length > 0) {
        dataPackCalendar.periods.push(dataPackCalendarPeriod);
      }
      dataPackCalendar.allPeriods.push(dataPackCalendarPeriod);
    }
    return dataPackCalendar;
  }

  private closeSaveCalendarForm() {
    this.calendar = null;
    this.editingCalendar = false;
  }

  private saveCalendar() {
    this.savingCalendar = true;
    let payload: any = {
      calendar: this.toDataPackCalendar()
    };
    this.calendarService.saveCalendar(payload).subscribe(
      data => {
        this.savingCalendar = false;
        this.alertService.success(data['result']);
        this.loadView();
        this.closeSaveCalendarForm();
      },
      err => {
        this.savingCalendar = false;
        this.alertService.error(err.result, err);
      }
    );
  }

  private openRemoveCalendarModal(calendar: DataPackCalendar) {
    let modalRef = this.modal.open(RemoveCalendarModalComponent);
    modalRef.componentInstance.calendar = calendar;
    modalRef.result.then(result => this.reloadView(), reason => null);
  }

  private reloadView(){
    this.calendars = null;
    this.loadView();
  }

  private openSetCalendarModal() {
    if (this.calendars.length === 0) {
      this.alertService.warn('Não existe calendário definido para empresa');
      return;
    }
    if (this.selectedLines.size === 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    let modalRef = this.modal.open(SetCalendarModalComponent);
    modalRef.componentInstance.group = this.selectedGroup;
    modalRef.componentInstance.lines = Array.from(this.selectedLines.values());
    modalRef.componentInstance.calendars = this.calendars;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private openUnsetCalendarModal() {
    if (this.selectedLines.size === 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    this.selectedLines.forEach(line => {
      if (!line.calendar) {
        this.selectedLines.delete(line.lineNumber);
      }
    });
    if (this.selectedLines.size === 0) {
      this.alertService.warn('Não existem calendários para as linhas selecionadas');
      return false;
    }
    let modalRef = this.modal.open(UnsetCalendarModalComponent);
    modalRef.componentInstance.group = this.selectedGroup;
    modalRef.componentInstance.lines = Array.from(this.selectedLines.values());
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private adjustHours(index: number) {
    let previousPeriod = this.calendar.periods[index - 1];
    let currentPeriod = this.calendar.periods[index];
    let validHours = false;
    if (this.isHourPatternValid(currentPeriod.initialHour)) {
      if (this.isHourValid(currentPeriod.initialHour)) {
        if (moment(currentPeriod.initialHour, this.hourFormat).isAfter(moment(currentPeriod.endHour, this.hourFormat))) {
          this.alertService.warn('Esta hora inicial n\u00E3o pode ser maior que a hora inicial da faixa seguinte!');
        } else if (moment(currentPeriod.initialHour, this.hourFormat).isSameOrBefore(moment(previousPeriod.initialHour, this.hourFormat))) {
          this.alertService.warn('Esta hora inicial n\u00E3o pode ser menor ou igual a hora inicial da faixa anterior!');
        } else {
          previousPeriod.endHour = moment(currentPeriod.initialHour, this.hourFormat).subtract(1, 'minutes').format(this.hourFormat);
          this.originalPeriods = _.cloneDeep(this.calendar.periods);
          validHours = true;
        }
      }
      if (!validHours) {
        currentPeriod.initialHour = this.originalPeriods[index].initialHour;
      }
    }
  }

  private isHourValid(value: string) {
    return moment(value, this.hourFormat).isValid();
  }

  private isHourPatternValid(value: string) {
    return new RegExp(this.hourPattern).test(value);
  }

  private listSpecialDays() {
    this.calendarService.listSpecialDays().subscribe(
      data => {
        let dataSpecialDays:any = <any> data;
        this.specialDays = dataSpecialDays;
        this.disableSaveDaySpecial=false;
      }
    );
  }

  private openCreateSpecialDays() {
    this.createSpecialDays = true;
  }
  private closeCreateSpecialDays() {
    this.createSpecialDays = false;
  }

  private configSpecialDays(selectedDate: any, specialDay: any, operationType: string) {
    let dataFormated: string ;
    let day:string;
    let month
    let monthNumber:number = selectedDate.month;
    let dayNumber:number = selectedDate.day;
    if(monthNumber < 10){
      month =  0+String(selectedDate.month).replace('0','');
    }else{
      month = selectedDate.month;
    }  
    if(dayNumber <10){
      day =  0+String(selectedDate.day).replace('0','');
    }else{
      day =  selectedDate.day;
    }

    dataFormated  =  day+"/"+month+"/"+selectedDate.year;
    let listFilter = _.filter(this.specialDays, function(item) {
        return item.day === dataFormated;
    });

    if(listFilter.length == 0){
      let dataPackCalendarSpecialDays:DataPackCalendarSpecialDays = <DataPackCalendarSpecialDays> { day: dataFormated, description: this.description };
      this.specialDays.push(dataPackCalendarSpecialDays);
      let conf = { date: dataFormated, operationType: '1', description: this.description };
      this.calendarService.configSpecialDay(this.specialDays, conf).subscribe(
        data => {
          this.alertService.success(data['result']);
        },
        err => {
          this.alertService.error(err.result, err);
        }
      );
    } else{ 
     this.alertService.warn("Dia especial já configurado");            
    }
  }

  private openRemoveSpecialModal(specialDay: any, operationType: string) {
    let modalRef = this.modal.open(RemoveSpecialDayComponent);
    modalRef.componentInstance.specialDays = this.specialDays;
    modalRef.componentInstance.model = specialDay;
    modalRef.result.then(result => this.listSpecialDays(), reason => null);
  }

  private maskMsisdn(msisdn: string): string {
    if (_.isNil(msisdn)) {
      return '';
    }
    if (msisdn.length == 12) {
      return '('.concat(msisdn.substr(0, 3)).concat(') ').concat(msisdn.substring(3, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    } else if (msisdn.length == 11) {
      return '('.concat(msisdn.substr(0, 2)).concat(') ').concat(msisdn.substring(2, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    }
    return msisdn;
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/calendar/content.component.ts